import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=a38bb1fc"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports